import $ from 'jquery';

$(document).ready(function() {
  $(".dea-pmp-select").on("change", function(e) {
    const pmp_id = $(this).val();
    $.get('dea_numbers', function(data) {
      const pathname = location.pathname;
      document.cookie = "dea_pmp_id=" + pmp_id + ";path=/";
      location.href = location.protocol + "//" + window.location.host + pathname;
    });
  });
});
